export default "__VITE_ASSET__DeU93dGJ__"